module.exports = __webpack_public_path__ + "static/media/issue books.7194ae67.svg";